export default __webpack_public_path__ + "static/media/book_image8.43ca787a.jfif";